// React Third Party Library
import { Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

// Services Library
import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util";

// Components Library
import DrawerCompany from "../DrawerCompany";

// Redux Library
import * as REDUX_ACTION from "../../../../services/redux/actions";

const { reduxStoreWrapper } = REDUX_UTIL;

const EditCompanyDrawer = (props) => {
  const { isDrawerOpen, setIsDrawerOpen, data } = props;
  const [form] = Form.useForm();
  const [ readOnly , setReadOnly ] = useState(true);

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage(); 

  const user = useSelector(reduxStoreWrapper("user"));
  const employer = useSelector(reduxStoreWrapper("employer.byID"));

  useEffect (() => {
    if(isDrawerOpen && Object.values(data).length > 0) {
      let picContact = data.pic?.contact.replace(/^(\+60)/, '');

      form.setFieldsValue({ 
        ...data,
        billing_date : TIME.getDayNumberFromEpochWithSuffix(data?.billing_date),
        billing_period : TIME.getDayNumberFromEpoch(data?.billing_period),
        pic : {
          ...data.pic,
          contact : picContact
        }
      })
    }
  }, [isDrawerOpen])

  const convertToEpoch = (date) => {
    const dayValue = parseInt(date);
    const currentDate = dayjs();
    const newDate = currentDate.date(dayValue);
    const epochTimestamp = newDate.valueOf();

    return epochTimestamp;
  }

  const editCompany = () => {
    form.validateFields().then((values) => {
      messageApi.open({
          type: "loading",
          content: "Updating company data...",
          duration: 0,
      });

      const emprArr = values?.listEmployer?.map(e => {
        const empr = Object.values(employer).find(option => option.uid === e.uid);
        return {uid: empr?.uid, name: empr?.name}
      })

      const { billing_date, billing_period, ...restValues } = values;
      const billingDateNumber = parseInt(billing_date); 
      const updatedValues = {
          ...restValues, 
          billing_date: convertToEpoch(billingDateNumber),
          billing_period: convertToEpoch(billing_period), 
          pic : {
            ...values.pic,
            contact : `+60${values.pic.contact}`
          }
      };

      const companyData = {
          items : {...updatedValues},
          coid : data.coid,
          updatedBy: user.memid,
          employers: emprArr
      };
      delete companyData.items.key;
      delete companyData.items.picName;  

      dispatch(
          REDUX_ACTION.v1_company.update_company_request(companyData, 
          ({status}) => {
            messageApi.destroy()
          })
      );
      form.resetFields();
      })
      .catch((err) => {
        message.error("fill the form");
      })
  }

  return (
    <>
        {contextHolder}
        <DrawerCompany
          form={form}
          isOpen={isDrawerOpen}
          setIsOpen={setIsDrawerOpen}
          type="Edit"
          handleSave={editCompany}
          data={data}
          readOnly={readOnly}
        />
    </>
  );
}

export default EditCompanyDrawer